<template>
    <BModal :model-value="modal" scrollable centered title="Room Status" hide-footer @update:modelValue="updateModal">
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Room Status</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="updateModal(false)"
            >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <BForm>
            <div class="form-group">
                <BFormInput type="text" v-model="roomStatusForm.icon" placeholder="Icon"></BFormInput>
            </div>
            <div class="form-group">
                <BFormInput type="text" v-model="roomStatusForm.name" placeholder="Name"></BFormInput>
            </div>
        </BForm>
        
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" @click="handleAction" class="mr-2">{{ roomStatusData && roomStatusData.uuid ? 'Update' : 'Save'}}</BButton>
                <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
            </div>
        </template> 
    </BModal>
</template>

<script>
import { BModal, BFormInput,BButton, BForm } from 'bootstrap-vue-next';
import { ref, inject, watch } from 'vue';

export default {
    components: {
        BModal,
        BFormInput,
        BButton,
        BForm
    },
    props: {
        modal: Boolean,
        roomStatusData: Object,
    },
    emits: ["update:modal"],
    setup(props, { emit }) {
        const repositories = inject('repositories');
        const roomStatusRepository = repositories ? repositories.roomStatus : null;

        const roomStatusForm = ref({
            name: '',
            description: ''
        });

        const updateModal = (value) => {
            emit("update:modal", value); // Sync modal state with parent
        }

        const handleAction =  () => {
            props.roomStatusData.uuid ? update() : create()
        }

        const create = async () => {
            await roomStatusRepository.create(roomStatusForm.value).then(() => {
                updateModal(false)
                roomStatusForm.value = {}
                emit("addOrUpdate");
            }).catch(err => {
                console.error(err)
            })
        }

        const update = async () => {
            await roomStatusRepository.update(roomStatusForm.value, props.roomStatusData.uuid).then(() => {
                updateModal(false)
                roomStatusForm.value = {}
                emit("addOrUpdate");
            }).catch(err => {
                console.error(err)
            })
        }

        watch(() => props.roomStatusData, (newData) => {
            if (newData) {
                roomStatusForm.value = { ...newData };
            }
        }, { immediate: true });

        return {
            roomStatusForm,
            updateModal,
            handleAction,
            create,
            update
        }
    }
}
</script>


